<template>
  <div class="document-page-container">
    <div class="document-page" :class="{ 'is-readonly': !isEditable }">

      <div class="page-header">
        <div class="client-block">
          <p class="block-label">Client</p>
          <!-- Client modifiable (devis en rédaction) : liste de choix ; sinon simplement son nom -->
          <div v-if="clientInput && !clientInput.readOnly" class="client-select">
            <CustomSelectField :content="clientInput" />
          </div>
          <p v-else class="client-name">{{ clientLabel() }}</p>
        </div>
        <div class="doc-meta-block">
          <p class="doc-type">{{ activeCategory }}</p>
          <!-- Numéro modifiable (devis en rédaction) : champ de saisie ; sinon simplement le numéro -->
          <div v-if="numberInput && !numberInput.readOnly" class="doc-number-field">
            <span class="doc-number-prefix">N°</span>
            <div class="doc-number-input">
              <CustomTextField :content="numberInput" />
            </div>
          </div>
          <p v-else class="doc-number-big">N° {{ activeDocumentNumber }}</p>
        </div>
      </div>

      <div class="page-divider"></div>

      <div class="title-field-wrap">
        <CustomTextField class="document-title-field" :content="titleInput" />
      </div>

      <BusinessElementsEdition :elements="businessElements"
                               :is-editable="isEditable"
                               :default-unit-price="defaultUnitPrice"
                               :default-tva-percent="defaultTvaPercent"
                               :totals="totals"
      />

      <div v-if="business && business.additionalInformation" class="additional-info-block">
        <p class="block-label">Informations complémentaires</p>
        <pre class="additional-info-text">{{ business.additionalInformation }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomSelectField from "@/components/forms/customs/customSelectField/CustomSelectField.vue";
import BusinessElementsEdition from "@/components/businessEdition/BusinessElementsEdition.vue";

export default {
  name: 'DocumentEditionPage',
  components: {CustomTextField, CustomSelectField, BusinessElementsEdition },
  props: {
    business: {type: Object, default: undefined},
    clientName: {type: String, default: ''},
    clientInput: {type: Object, default: undefined},
    numberInput: {type: Object, default: undefined},
    activeCategory: {type: String, default: ''},
    activeDocumentNumber: {type: [String, Number], default: ''},
    titleInput: {type: Object, required: true},
    businessElements: {type: Array, required: true},
    totals: {type: Object, required: true},
    isEditable: {type: Boolean, required: true},
    defaultUnitPrice: {default: undefined},
    defaultTvaPercent: {default: undefined},
  },
  data() {
    return {
      selfTitleInput: this.titleInput
    }
  },
  watch: {
    // Le titre suit le même droit d'édition que les lignes du document (isEditable) : éditable en rédaction, figé sinon
    isEditable: {
      immediate: true,
      handler(isEditable) {
        this.selfTitleInput.readOnly = !isEditable;
      }
    }
  },
  methods: {
    clientLabel() {
      return this.clientName || (this.business ? this.business.currentClientName : '');
    }
  }
};
</script>

<style lang="stylus" scoped>
/* ---------- Page A4 ---------- */

.document-page-container
  flex 1 1 0
  min-width 0
  max-height calc(92vh - 150px)
  overflow-y auto
  display flex
  justify-content center
  padding 36px 48px

  border-radius 6px
  box-shadow 0 8px 24px rgba(20, 25, 35, 0.12), 0 1px 2px rgba(20, 25, 35, 0.08)
  box-sizing border-box
  background-color #ffffff

.document-page
  width 100%

  &.is-readonly
    background-color #fcfcfb

.block-label
  margin 0 0 4px
  font-size 10px
  font-weight 700
  letter-spacing 0.08em
  text-transform uppercase
  color #adb1b6

.page-header
  display flex
  justify-content space-between
  align-items flex-end
  gap 20px

  .client-block
    .client-name
      margin 0
      font-size 14px
      font-weight 600
      color #24272b

    .client-select
      width 280px
      max-width 100%

  .doc-meta-block
    text-align right
    display flex
    flex-direction column
    align-items flex-end
    min-width 140px

    .doc-type
      margin 0
      font-size 10px
      font-weight 700
      letter-spacing 0.1em
      text-transform uppercase
      color THEME_COLOR_PRIMARY

    .doc-number-big
      margin 2px 0 0
      font-size 18px
      font-weight 700
      color #24272b

    .doc-number-field
      display flex
      align-items center
      gap 8px
      margin-top 2px

      .doc-number-prefix
        font-size 18px
        font-weight 700
        color #24272b

      // Le champ prend toute la largeur de ce conteneur (CustomTextField compense lui-même ses 8px de marge)
      .doc-number-input
        width 104px

        :deep(input)
          font-size 16px
          font-weight 700
          text-align right

.document-page.is-readonly
  .page-header
    .client-name, .doc-type, .doc-number-big
      color #6b7076

.page-divider
  height 1px
  background-color #e7e8ea
  margin 16px 0

.title-field-wrap
  margin-bottom 20px
  max-width 520px

.additional-info-block
  margin-top 20px
  padding-top 16px
  border-top 1px dashed #e7e8ea

  .additional-info-text
    margin 0
    font-family inherit
    font-size 12px
    line-height 1.5
    color #8b8f95
    white-space pre-wrap
</style>